<template>
  <div id="app">
    <div v-if="systemNotice" class="global-notice">{{ systemNotice }}</div>
    <router-view />
  </div>
</template>

<script>
import globalWs from '@/services/globalWs'

export default {
  name: 'App',
  data () {
    return {
      systemNotice: '',
      noticeTimer: null,
      unsubscribe: null
    }
  },
  mounted () {
    this.bootGlobalWs()
    window.addEventListener('storage', this.bootGlobalWs)
    this.unsubscribe = globalWs.subscribe((event) => {
      if (event.type === 'system' && event.content) {
        this.systemNotice = event.content
        if (this.noticeTimer) clearTimeout(this.noticeTimer)
        this.noticeTimer = setTimeout(() => {
          this.systemNotice = ''
        }, 3000)
      }
    })
  },
  beforeUnmount () {
    window.removeEventListener('storage', this.bootGlobalWs)
    if (this.unsubscribe) this.unsubscribe()
    if (this.noticeTimer) clearTimeout(this.noticeTimer)
  },
  methods: {
    bootGlobalWs () {
      const token = localStorage.getItem('token')
      if (token) {
        globalWs.connect(token)
      } else {
        globalWs.disconnect()
      }
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'Cubic_11';
  src: url('./assets/Cubic_11.woff2') format('woff2');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

#app {
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-text);
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  padding: 0;
  font-family: var(--font-family);
  /* 全局禁止文字选择 */
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

* {
  font-family: var(--font-family);
}

.global-notice {
  position: fixed;
  top: 14px;
  left: 50%;
  transform: translateX(-50%);
  z-index: var(--z-toast);
  background: var(--color-overlay-toast);
  color: var(--color-on-primary);
  padding: 8px 14px;
  border-radius: var(--radius-sm);
}
</style>
